// @spec SCF-004
// Root route - redirects to dashboard (authenticated) or sign-in (unauthenticated)
import { useAuth } from '@clerk/clerk-react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/')({
  component: IndexPage,
});

function IndexPage() {
  const { isLoaded, isSignedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoaded) return;

    if (isSignedIn) {
      void navigate({ to: '/dashboard', replace: true });
    } else {
      void navigate({ to: '/sign-in', replace: true });
    }
  }, [isLoaded, isSignedIn, navigate]);

  // Show loading state while Clerk loads auth state
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}
